import { useMemo, useState, useCallback, useEffect } from 'react'

import getDaysForTheCalendar from './functions/getDaysForTheCalendar'
import getMonthByIndex from './functions/getMonthByIndex'

type ListOfDayItem = {
  stringDate: string
  isThisMounth?: boolean
  day?: number
}

export type ListOfDays = ListOfDayItem & {
  [key: number]: ListOfDayItem
}

export default function useCalendar(customMonth?: number) {
  const defaultMonth = customMonth || new Date().getMonth()
  const defaultYear = new Date().getFullYear()

  const [daysInCalendar, setDaysInCalendar] = useState<ListOfDays[]>([])
  const [month, setMonth] = useState(defaultMonth)
  const [year, setYear] = useState(defaultYear)

  const stringMonth = useMemo(() => {
    return getMonthByIndex(month)
  }, [month])

  useEffect(() => {
    if (customMonth === -1) {
      setMonth(11)
      setYear(defaultYear - 1)
    }
  }, [])

  useEffect(() => {
    const listOfDays = getDaysForTheCalendar(month, year)

    setDaysInCalendar(listOfDays)
  }, [month, year])

  const nextMonth = useCallback(() => {
    if (month !== 11) {
      setMonth(month + 1)
    } else {
      setMonth(0)

      setYear(year + 1)
    }
  }, [month, year])

  const previousMonth = useCallback(() => {
    if (month > 0) {
      setMonth(month - 1)
    } else {
      setMonth(11)
      setYear(year - 1)
    }
  }, [month, year])

  const resetCalendar = useCallback((month: number, year: number) => {
    setMonth(month)
    setYear(year)
  }, [])

  return {
    stringMonth,
    resetCalendar,
    previousMonth,
    nextMonth,
    daysInCalendar,
    year,
  }
}
